/*
 * Usage:
 *   const scrollLimited = scrollLimitedService.create(scrolledEl);
 *   document.addEventListener('resize', function () {
 *     // calculate elTop, elBottom
 *     scrollLimited.setLimits(elTop, elBottom)
 *     if (condition to start) {
 *       scrollLimited.start();
 *     } else {
 *       scrollLimited.stop();
 *     }
 *   });
 * Note: Set event listener for setLimits before start.
 */

class ScrollLimited {

  /**
   * @param object scrolledEl (node element)
   */
  constructor (scrolledEl) {
    this.enabled = false;
    this.scrolledEl = scrolledEl;
    this.limitTop = 0;
    this.limitBottom = window.innerHeight;
    this.lastScrollTop = 0;
    this.debug = false;
  }

  /**
   * @param number elTop
   * @param number elBottom
   */
  setLimits (elTop, elBottom) {
    this.limitTop = elTop;
    this.limitBottom = elBottom;
    this.onScrollOrResize();
  }

  /**
   * @param bool
   */
  setDebug(debug) {
    this.debug = debug;
  }

  /**
   */
  start() {
    if (!this.enabled && this.scrolledEl != null) {
      if (this.debug) {
        console.log('start');
      }
      this.scrolledEl.style.position = 'relative';
      document.addEventListener('scroll', this.onScrollOrResize.bind(this));
      window.addEventListener('resize', this.onScrollOrResize.bind(this));
      this.enabled = true;
      this.onScrollOrResize(undefined);
    }
  }

  /**
   */
  stop() {
    if (this.enabled) {
      if (this.debug) {
        console.log('stop');
      }
      document.removeEventListener('scroll', this.onScrollOrResize.bind(this));
      window.removeEventListener('resize', this.onScrollOrResize.bind(this));
      this.enabled = false;
      this.onScrollOrResize();
    }
  }

  onScrollOrResize (event) {
    if (this.enabled) {
      const [limitTop, limitBottom] = [this.limitTop, this.limitBottom];
      const [elTop, elBottom] = this.getTopBottomFromEl(this.scrolledEl);
      const currentStyleTop = this.scrolledEl.style.top;
      const scrollTop = window.scrollY;
      let elStyleTop = parseInt(this.scrolledEl.style.top);
      if (isNaN(elStyleTop)) {
        elStyleTop = 0;
      }
      let elStyleTopDiff = 0;
      if (elBottom - elTop < limitBottom - limitTop) {
        elStyleTopDiff = limitTop - elTop;
      } else {
        if (scrollTop > this.lastScrollTop) {
          if (elBottom < limitBottom) {
            elStyleTopDiff = limitBottom - elBottom;
          }
        } else {
          if (elTop > limitTop) {
            elStyleTopDiff = limitTop - elTop;
          }
        }
      }
      this.scrolledEl.style.top = (elStyleTop + elStyleTopDiff) + 'px';
      this.lastScrollTop = scrollTop;
    }
    else {
      this.lastScrollTop = 0;
      this.scrolledEl.style.top = '';
    }
  }

  /**
   * @param object el element
   * @return array [number, number]
   */
  getTopBottomFromEl (el) {
    const rect = el.getBoundingClientRect();
    return [rect.top, rect.top + el.offsetHeight];
  }

}

/**
 * @param object scrolledEl dom elemetn
 */
const create = (scrolledEl) => {
  return new ScrollLimited(scrolledEl)
}

/* Export object, as a factory */
export default {
  create,
}
